// extracted by mini-css-extract-plugin
module.exports = {"text":"referral-banner_text__cePlY"};